export function getBoundingBoxFromFlatCoords( coordinates ) {
    const highToLow = ( a, b ) => {
        return b - a;
    };

    const longitudes = coordinates.map( ( coord ) => {
        return coord[ 0 ];
    } ).sort( highToLow );

    const latitudes = coordinates.map( ( coord ) => {
        return coord[ 1 ];
    } ).sort( highToLow );

    return [
        [
            longitudes[ longitudes.length - 1 ],
            latitudes[ latitudes.length - 1 ]
        ],
        [
            longitudes[ 0 ],
            latitudes[ 0 ]
        ]
    ];
}

export function getBBOXCenter( bbox ) {
    return {
        lat: bbox.northEast.lat - ( ( bbox.northEast.lat - bbox.southWest.lat ) / 2 ),
        lon: bbox.southWest.lon - ( ( bbox.southWest.lon - bbox.northEast.lon ) / 2 )
    };
}

export function withAdjacentDuplicatesRemoved( coordinates = [] ) {
    return coordinates.filter( ( coordinate, index ) => {
        if ( index === 0 ) {
            return true;
        }

        const previous = {
            lat: coordinates[ index - 1 ][ 1 ],
            lon: coordinates[ index - 1 ][ 0 ]
        };

        const lat = coordinate[ 1 ];
        const lon = coordinate[ 0 ];

        if ( previous.lat === lat && previous.lon === lon ) {
            return false;
        }

        return true;
    } );
}



// WEBPACK FOOTER //
// ./src/spatial.js